<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList>
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="code"
                                       label="Code"
                                       size="3"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.code" />

                        <FormInputText fieldName="name"
                                       label="Name"
                                       size="3"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.name" />

                        <FormInputText fieldName="country_code"
                                       label="Country Code"
                                       size="3"
                                       :validation="['required']"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.country_code" />

                        <FormInputToggleButton fieldName="is_active"
                                               label="Is active marketplace?"
                                               size="3"
                                               :isFormDisabled="isFormDisabled"
                                               v-model:field="crud.is_active" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="base_url_prod"
                                       label="Production Base URL"
                                       size="6"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.base_url_prod" />

                        <FormInputText fieldName="base_url_sandbox"
                                       label="Sandbox Base URL"
                                       size="6"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.base_url_sandbox" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="auth_url_prod"
                                       label="Production Auth URL"
                                       size="6"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.auth_url_prod" />

                        <FormInputText fieldName="auth_url_sandbox"
                                       label="Sandbox Auth URL"
                                       size="6"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.auth_url_sandbox" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="driver_class"
                                       label="Driver Class"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.driver_class" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from "@pages/Helper/crud_utils.js";
import FormInputText from "@crud/FormInputText.vue";
import FormButtons from "@crud/FormButtons.vue";
import FormInputToggleButton from "@crud/FormInputToggleButton.vue";
import ChangeLog from "@crud/ChangeLog.vue";
import { __ } from "@pages/Helper/utils.js";
import { onFilterService } from "@pages/Helper/crud_utils.js";

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
});

const isLoading = ref(true);
const isFormDisabled = ref(false);

const options = ["sellers"];
const select = ref(null);
const crud = ref({});
const buttonsVisibility = ref({});

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select, buttonsVisibility);
});

// -----------------------------------------------------

const onFilter = async (event, option) => {
    await onFilterService(event, option, select, isLoading);
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
